import { useContext } from "react";
import { CookieConsentContext, type CookieConsentContextValue } from "../utils/cookieConsentContext";

export default function useCookieConsent(): CookieConsentContextValue {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error("useCookieConsent must be used within a CookieConsentProvider");
  return ctx;
}
